import instance from "../services/services";
import { IDENTITY_VERIFICATION_URL } from "../utils/urls";

// 앱 여부 판별 함수 개선
const isInApp = () => {
    // 1. User-Agent 확인 (대소문자 무시)
    const userAgent = navigator.userAgent || '';
    const isAppByUserAgent = /yourAppName|AppWebView/i.test(userAgent);
    
    // 2. ReactNativeWebView 객체 확인
    const hasReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';
    
    // 3. 앱 환경에서 주입되는 다른 객체나 메서드 확인 (예시)
    const hasAppBridge = typeof window.AppInterface !== 'undefined' || 
                            typeof window.webkit?.messageHandlers?.AppInterface !== 'undefined';
    
    // 4. URL에서 앱 관련 파라미터 확인
    const isAppByUrl = window.location.href.includes('app=true');
    
    
    // 앱으로 판단되는 경우 true 반환
    return isAppByUserAgent || hasReactNativeWebView || hasAppBridge || isAppByUrl;
    };

const useIdentityVerification = ({ context, extraData, memberKind }) => {
    const handleIdentity = async () => {
        try {
            // 환경에 맞는 baseUrl 사용
            const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
            const finalReturnUrl = `${baseUrl}/auth/verification/result?context=${context || 'default'}${context === 'PasswordFind' && extraData?.userId ? `&userId=${extraData.userId}` : ''}${memberKind ? `&memberKind=${memberKind}` : ''}`;
            
            const response = await instance.post(IDENTITY_VERIFICATION_URL, {   
                returnUrl: finalReturnUrl
            });

            
            const { enc_data, integrity_value, token_version_id } = response?.data?.data || {};

            if (!enc_data || !integrity_value || !token_version_id) {
                throw new Error("본인인증 데이터가 유효하지 않습니다.");
            }

            // 앱 환경에서는 리다이렉션 방식 사용
            if (isInApp()) {
                // 현재 페이지 경로 저장 (리다이렉션 후 돌아올 위치)
                const currentPath = window.location.pathname;
                
                // 동적으로 폼 생성 후 제출
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
                form.style.display = 'none';
                
                form.innerHTML = `
                    <input type="hidden" name="m" value="service" />
                    <input type="hidden" name="enc_data" value="${enc_data}" />
                    <input type="hidden" name="integrity_value" value="${integrity_value}" />
                    <input type="hidden" name="token_version_id" value="${token_version_id}" />
                    <input type="hidden" name="receivedata" value="${enc_data}" />
                `;
                
                // 원래 페이지 경로를 localStorage에 저장
                localStorage.setItem('auth_return_path', currentPath);
                localStorage.setItem('auth_context', context); // context도 저장
                localStorage.setItem('member_kind', memberKind); // 회원 유형도 저장
                
                document.body.appendChild(form);
                form.submit();
                return;
            }
            
            // 웹 환경에서는 기존 팝업 방식 사용
            const left = window.screen.width / 2 - 500 / 2;
            const top = window.screen.height / 2 - 600 / 2;
            const option = `status=no, menubar=no, toolbar=no, resizable=no, width=500, height=600, left=${left}, top=${top}`;
            
            // 팝업 열기
            const popup = window.open('', 'nicePopup', option);
            
            if (!popup || popup.closed) {
                alert('팝업이 차단되었습니다. 브라우저 설정을 확인해주세요.');
                return;
            }
            
            // 회원 유형을 localStorage에 저장 (팝업 완료 후 사용)
            localStorage.setItem('member_kind', memberKind);
            
            // 페이지에 있는 form 요소 찾기
            const form = document.getElementById('niceAuthForm');
            if (!form) {
                console.error('본인인증 폼이 존재하지 않습니다.');
                popup.close();
                return;
            }
            
            form.target = 'nicePopup';
            form.m.value = 'service';
            form.enc_data.value = enc_data;
            form.integrity_value.value = integrity_value;
            form.token_version_id.value = token_version_id;
            
            // 폼에 receivedata 필드가 없다면 동적으로 생성
            if (!form.receivedata) {
                const receiveDataInput = document.createElement('input');
                receiveDataInput.type = 'hidden';
                receiveDataInput.name = 'receivedata';
                receiveDataInput.value = enc_data;
                form.appendChild(receiveDataInput);
            } else {
                form.receivedata.value = enc_data;
            }
            
            // 폼 제출
            form.submit();
        } catch (err) {
            console.error('본인인증 요청 실패:', err.message);
            alert('본인인증 요청 중 문제가 발생했습니다: ' + err.message);
        }
    };

    return { handleIdentity };
};

export default useIdentityVerification;
